@if (!isDynamicdashboard) {
  <h2><a [ecommerceRouterLink]="['/:lang/news']"><mibp-resource-string key="Dashboard_LatestNews"></mibp-resource-string></a></h2>
}

@if (newsArticles?.length > 0 && !isLoading) {
  <div>
    <mibp-news-carousel class="promotion-card"[newsArticles]="newsArticles">
    </mibp-news-carousel>
  </div>
}

@if (isLoading) {
  <mibp-loader></mibp-loader>
}

@if (hasError) {
  <div class="my-discreet-error">
    <p><mibp-resource-string key="Global_Error_DataCouldNotBeLoaded"></mibp-resource-string></p>
    <p><a href="javascript:void(0)" (click)="load()"><mibp-resource-string key="Global_Action_TryAgain"></mibp-resource-string></a></p>
  </div>
}
